// Feature Module
// User for resource on the main entry point
// Try to keep this module lean

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WelcomeComponent } from './welcome/welcome.component';
import { SchoolNotFoundComponent } from './school-not-found/school-not-found.component';
import { StatusComponent } from './status/status.component';

import { NpcRootComponent } from './npc-root/npc-root.component';
import { TermsComponent } from './terms/terms.component';
import { SharedModule } from '_shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    declarations: [
        WelcomeComponent,
        SchoolNotFoundComponent,
        StatusComponent,
        NpcRootComponent,
        TermsComponent
    ]
})
export class WelcomeModule { }
